import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import 'zone.js';
import 'zone.js/plugins/zone-patch-rxjs';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

registerLocaleData(localeEs, 'es-MX');
bootstrapApplication(App, appConfig).catch((err) => console.error(err));
